export default __webpack_public_path__ + "static/icons8-email-4e4f65909d00e75039c8e3a93233efc7.svg";